import React from "react";
import { Table } from "antd";
import { Form } from "react-final-form";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const RemoveSelectedHierarchyModal = ({
  isDeleteHierarchyList,
  toggleDeleteHierarchyList,
  onDeleteHierarchyList,
  columnsDeleteHierarchyList,
  deleteHierarchyListData,
}) => {
  return (
    <>
      <Modal
        className={`modal-event-delete-hierarchy-list modal-lg`}
        isOpen={isDeleteHierarchyList}
        toggle={toggleDeleteHierarchyList}
      >
        <ModalHeader>
          <div>
            Please select the events that you wish to delete from the programs
          </div>
        </ModalHeader>
        <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
          <Form onSubmit={onDeleteHierarchyList}>
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <>
                <form className="form d-block" onSubmit={handleSubmit}>
                  <div style={{ padding: "10px" }}>
                    <Button
                      outline
                      className="btn btn-primary btn-sm"
                      color="#ffffff"
                    >
                      Delete
                    </Button>
                    <Button
                      outline
                      color="primary"
                      className="btn btn-sm ml-2"
                      onClick={toggleDeleteHierarchyList}
                      // style={{ float: "right" }}
                    >
                      Cancel
                    </Button>
                  </div>
                  <Table
                    pagination={false}
                    rowKey="event_id"
                    columns={columnsDeleteHierarchyList}
                    dataSource={deleteHierarchyListData}
                  />
                </form>
              </>
            )}
          </Form>
        </ModalBody>
      </Modal>{" "}
    </>
  );
};

export default RemoveSelectedHierarchyModal;
